import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    '&:hover $expandDivider': {
      backgroundColor: theme.palette.primary.light,
      opacity: 1,
    },
    '&:hover $expandToggle': {
      opacity: 1,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  containerExpand: {
    width: 200,
  },
  containerCollapse: {
    width: 56,
  },
  listContainer: {
    flexGrow: 1,
  },
  settingsContainer: {
  },
  list: {
    flexGrow: 1,
  },
  listSubheader: {
    color: theme.palette.text.secondary,
  },
  listItem: {
    cursor: 'pointer',
    color: theme.palette.grey[700],
    '&:hover': {
      '& $listItemIcon': {
        color: theme.palette.primary.main,
      },
      '& $listItemText': {
        color: theme.palette.primary.main,
      },
    },
    '& + &': {
      marginTop: theme.spacing(1),
    },
  },
  activeListItem: {
    '& $listItemText': {
      color: theme.palette.primary.main,
    },
    '& $listItemIcon': {
      color: theme.palette.primary.main,
    },
  },
  listItemIcon: {
    color: theme.palette.grey[700],
    minWidth: 24,
  },
  listItemText: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginLeft: theme.spacing(1),
    height: 24,
    marginTop: 0,
    marginBottom: 0,
  },
  listDivider: {
    margin: theme.spacing(1),
  },
  expandContainer: {
    margin: theme.spacing(2),
    marginLeft: 0,
    zIndex: 1,
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
  },
  expandDivider: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  expandToggle: {
    position: 'absolute',
    cursor: 'pointer',
    opacity: 0,
    width: 24,
    height: 24,
    marginTop: theme.spacing(4) + 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 24,
    backgroundColor: theme.palette.background.paper,
    '& > svg': {
      width: 24,
      height: 24,
      color: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      '& > svg': {
        color: theme.palette.background.paper,
      },
    },
  },
  settingsMenu: {
    marginLeft: theme.spacing(2),
  },
  settingsMenuList: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  paper: {
    marginRight: theme.spacing(2),
  },
});

export default styles;
